<template>
    <transition
            name="fade"
            v-on:after-enter="beforeEnter"
    >
    <div class="popover" v-show="visible" v-bind:style="[position === 'top' ? {'top': height + 'px'} : {'bottom': height + 'px'}, visible ? {'visibility': 'visible'} : {'visibility': 'hidden'}]" ref="element">
        <div v-if="value.customer" class="popover-customer">
            <div>
                {{ value.customer.name }}
            </div>
        </div>
        <div v-if="value.total" class="popover-total">
            {{ value.total }} {{ currency }}
        </div>
        <div v-for="(task, key) in value.tasks" class="popover-service">
            {{ task.service.name }} ({{ task.service.price }}
        </div>
        <div v-if="value.note" class="popover-note">
            {{ value.note }}
        </div>
        <div class="popover-action">
                    <span  class="popover-button info" :data-tooltip="$t('label.edit')">
                        <span aria-hidden="true" class="icon icon-edit"></span>
                    </span>
            <span class="popover-button info" :data-tooltip="$t('label.delete')">
                        <span class="icon icon-trash" aria-hidden="true"></span>
                    </span>
        </div>
    </div>
    </transition>
</template>
<script>
    export default {
      name: 'PopoverWidget',
      props: ['value'],
      mounted () {
        this.setPopoverPosition()
        this.$events.$on('message-open', eventData => this.open(eventData))
      },
      data () {
        return {
          visible: false,
          height: 0,
          offset: 10,
          position: 'top'
        }
      },
      methods: {
        show () {
          this.visible = true
        },
        hide () {
          this.visible = false
        },
        toggle () {
          this.visible = !this.visible
        },
        setPopoverPosition () {
          this.height = -(this.$refs.element.clientHeight + this.offset)
          console.log(this.height)
        },
        beforeEnter () {
          this.setPopoverPosition()
        }
      },
      destroyed () {
        this.$events.$off('message-open')
      }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/widgets/PopoverWidget.vue